import script from "./manualInspection2.vue?vue&type=script&setup=true&lang=ts"
export * from "./manualInspection2.vue?vue&type=script&setup=true&lang=ts"

import "./manualInspection2.vue?vue&type=style&index=0&id=9d22e7d8&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d22e7d8"]])

export default __exports__